import React, { Fragment } from "react";

import { useWindowWidth } from "../../hooks/use-breakpoint";

/**
 * Render-prop access to the viewport width, unchanged for its 16 call sites.
 *
 * The subscription now lives in `use-breakpoint`, shared with every other
 * consumer: this component used to register a resize listener on every render
 * and never remove it.
 */
const ResizeWrapper = (props) => {
  const { render } = props;
  const resizeWidth = useWindowWidth();

  return <Fragment>{render(resizeWidth)}</Fragment>;
};

export default ResizeWrapper;
